import { createAuthSession, installAuthSession } from '@hb/auth-client';
import { createAppI18n, detectLocale } from '@hb/i18n';
import { initTheme } from '@hb/ui';
import '@hb/ui/tokens.css';
import { createApp } from 'vue';
import App from './App.vue';
import './app.css';
import { API_URL } from './config.js';
import { createAppRouter } from './router.js';

initTheme();

/**
 * The session is created before the router, because the guards need it, and the
 * router is needed to react to a session ending - hence the indirection through
 * a mutable handler rather than a direct reference either way.
 */
let handleSignedOut = (): void => undefined;

const session = createAuthSession({
  baseUrl: API_URL,
  onSignedOut: () => {
    handleSignedOut();
  },
});

const router = createAppRouter(session);

handleSignedOut = () => {
  // `replace`, not `push`: a session that has been taken away should not leave
  // a history entry the back button can return to.
  void router.replace({ path: '/login' });
};

// The browser's language is only a starting point. Once the session settles,
// App.vue switches to the preference stored on the account, which is also the
// language their email is written in - the two must not disagree.
const i18n = createAppI18n(detectLocale());

const app = createApp(App);
installAuthSession(app, session);
app.use(i18n).use(router).mount('#app');
